export const planTabs = ["planner", "history"] as const;
export type PlanTab = (typeof planTabs)[number];

export const historyRanges = ["1M", "3M", "6M", "1Y", "ALL"] as const;
export type HistoryRange = (typeof historyRanges)[number];

const isPlanTab = (value: string | null): value is PlanTab => planTabs.some((tab) => tab === value);
const isHistoryRange = (value: string | null): value is HistoryRange => historyRanges.some((range) => range === value);

export function readPlanLocation(pathname: string, search: string) {
  const pathMatch = /^\/plan\/([^/]+)\/?$/.exec(pathname);
  const params = new URLSearchParams(search);
  const tab = params.get("tab");
  const range = params.get("range");
  let planId: string | null = null;

  if (pathMatch) {
    try {
      planId = decodeURIComponent(pathMatch[1]);
    } catch {
      planId = null;
    }
  }

  return {
    planId,
    tab: isPlanTab(tab) ? tab : "planner",
    range: isHistoryRange(range) ? range : "3M",
  };
}

export function planHref(planId: string | null, tab: PlanTab, range: HistoryRange = "3M") {
  const params = new URLSearchParams({ tab });
  if (tab === "history") params.set("range", range);
  const pathname = planId ? `/plan/${encodeURIComponent(planId)}` : "/plan";
  return `${pathname}?${params.toString()}`;
}
